import "src/decidim/initiatives/application";
import "src/decidim/initiatives/scoped_type";
import "src/decidim/initiatives/initiative_creation_wizard";
require.context("../images", true);
import "stylesheets/initiatives.scss";
